import React from 'react';
import { Typography, Avatar, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledAvatar = styled(Avatar)(() => ({
    width: 120,
    height: 120,
    border: '2px solid white',
    borderColor: 'rgba(194, 237, 248, 0.96)',
    boxShadow: '0px 4px 10px rgba(194, 237, 248, 0.96)',
    backgroundColor: '#fff',
    '& img': {
        objectFit: 'contain',
    },
}));

const HeadingText = styled(Typography)(() => ({
    fontSize: 20,
    fontWeight: 'bold',
    fontFamily: 'lato',
    color: '#2f75a3',
    textAlign: 'center',
}));

const SubText = styled(Typography)(() => ({
    fontFamily: 'lato',
    color: 'gray',
    textAlign: 'center',
}));

const LoginHeader = ({ type }) => {
    return (
        <>
            <Stack alignItems="center" mb={2}>
                <StyledAvatar
                    src="https://aimapms-staging-public.s3.us-east-1.amazonaws.com/AIMA_Logo.png"
                    alt="Medical Professional"
                />
            </Stack>

            {type === 'login' ? (
                <>
                    <HeadingText>Welcome Back</HeadingText>
                    <SubText variant="body2">Sign in to your account</SubText>
                </>
            ) : (
                <>
                    <HeadingText>Forgot Password</HeadingText>
                    <SubText variant="body2">
                        Enter your email to receive a password reset link
                    </SubText>
                </>
            )}
        </>
    );
};

export default LoginHeader;
